<template>
  <div>
      <div class="px-5 py-2">      
          <div class="d-flex"> 
              <div  class="btn-home-2 mb-2 mt-3 ms-auto">
                  <button type="button" class="btn btn-outline-main" @click="returnHome">
                      <i class="fas fa-home-lg-alt"></i> Inicio
                  </button>
              </div>
          </div>

          <ul class="nav pb-0" id="myTab" role="tablist">
              <li class="nav-item  " role="presentation">
                  <button
                    @click="changePage('reserva')" 
                    :class="{'item-button':true, 'nav-link': true, 'active': page === 'reserva' }"
                    id="home-tab" 
                    type="button" 
                   >
                     <strong>RESERVA</strong> 
                  </button>
              </li>
              <li class="nav-item  " role="presentation">
                  <button
                    @click="changePage('listaReser')" 
                    :class="{'item-button':true, 'nav-link': true, 'active': page === 'listaReser' }"
                    id="home-tab" 
                    type="button" 
                   >
                     <strong>LISTA DE RESERVA</strong> 
                  </button>
              </li>
              <li class="nav-item  " role="presentation">
                  <button
                    @click="changePage('servicios')" 
                    :class="{'item-button':true, 'nav-link': true, 'active': page === 'servicios' }"
                    id="home-tab" 
                    type="button" 
                   >
                     <strong>SERVICIOS</strong> 
                  </button>
              </li>
          </ul>
          <div class="tab-content border border-main mb-4 p-2" style="height: 50%;" >
              <ReservasVue  class="mt-2" v-if="page == 'reserva'" />
              <ListaReserVue  class="mt-2" v-if="page == 'listaReser'" />
              <ServiciosVue  class="mt-2" v-if="page == 'servicios'" />
          </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ReservasVue from "./Rehabilitacion/Reservas.vue";
import ListaReserVue from "./Rehabilitacion/ListaReser.vue";
import ServiciosVue from "./Rehabilitacion/Servicios.vue";
export default {

name:"logis-maintenance",
components:{
  SweetAlert,
  ReservasVue,
  ListaReserVue,
  ServiciosVue
},
data(){
  return{
      page: "reserva",
  }
},
created() {
},
methods:{
  ...mapActions(["get", "post"]),

  changePage: function (page) {
    this.page = page;
  },
  returnHome: function () {
    this.$emit("returnHome");
  },
}
}
</script>

<style scoped>
.h4-borde{
  border-radius: 50px;
}
#myTabContent{
  border:#2c3c5c 1.9px solid;
}

.item-button{
  background: #A9A9A9 !important;
  border-radius: 10px 10px 0px 0px;   
  border: none !important;
  color:white !important;
  width: 155px;   
}
.item-button1{
  background: #A9A9A9 !important;
  border-radius: 10px 10px 0px 0px;   
  border: none !important;
  color:white !important;
  width: 160px !important;    
}

.nav-link:hover{
  background:#2c3c5c !important
}
.active {
background-color: #2c3c5c !important ;

}
.nav-item{
  width: 159.39px;
}
</style>